import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GetMultipleBallparkInfoAPI } from "api/other";
import { GetBallparkInfoAPI } from "api/other";

const handleThunkError = (err, rejectWithValue) => {
  return rejectWithValue(
    err?.response?.data || {
      success: false,
      message: "Something went wrong",
    }
  );
};

const initialState = {
  info: [],
  infoList: [],
  loading: false,
};

export const getBallparkInfo = createAsyncThunk(
  "other/getBallparkInfo",
  async (data, { rejectWithValue }) => {
    try {
      const response = await GetBallparkInfoAPI(data);
      return response.data;
    } catch (err) {
      console.log("Ballpark Info error ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  }
);
export const getMultipleBallparkInfo = createAsyncThunk(
  "other/getMultipleBallparkInfo",
  async (data, { rejectWithValue }) => {
    try {
      const response = await GetMultipleBallparkInfoAPI(data);
      return response.data;
    } catch (err) {
      console.log("Multiple Ballpark Info error ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const slackSlice = createSlice({
  name: "others",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(getBallparkInfo.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBallparkInfo.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.info = payload.info;
      })
      .addCase(getBallparkInfo.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getMultipleBallparkInfo.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMultipleBallparkInfo.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.infoList = payload.infoList;
      })
      .addCase(getMultipleBallparkInfo.rejected, (state, action) => {
        state.loading = false;
      }),
});

export default slackSlice.reducer;
